import { apiPut } from "../baseApi";
import { setDistrictData } from "service/mapper";

export const update = async (data, id) => {
  try {
    const response = await apiPut("_district", id, data);
    return { ...response, data: setDistrictData(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
